<div class="overlay" data-testid="drawing-compare-overlay">
  <div class="overlay-controls">
    <label class="balance mat-body-1">
      <span>{{ revisionName(older) }}</span>
      <input type="range" min="0" max="100" step="1" [value]="balance" data-testid="drawing-compare-balance"
        [attr.aria-label]="revisionName(older) + ' to ' + revisionName(newer)" (input)="setBalance(+$any($event.target).value)" />
      <span>{{ revisionName(newer) }}</span>
    </label>
    <label class="toggle mat-body-1"><input type="checkbox" data-testid="drawing-compare-show-removed" [checked]="showRemoved"
      (change)="setRemoved($any($event.target).checked)" /> Show removed</label>
    <label class="toggle mat-body-1"><input type="checkbox" data-testid="drawing-compare-show-added" [checked]="showAdded"
      (change)="setAdded($any($event.target).checked)" /> Show added</label>
    <!-- Auto-align (api 93fa28af) is applied on open; Align manually only offers itself when there is none to apply -->
    @if (!aligning) {
      @if (aligned) {
        <span class="align-status mat-body-1" data-testid="drawing-compare-aligned">Aligned manually</span>
        <button type="button" class="link-button mat-body-1" data-testid="drawing-compare-align-reset" (click)="resetAlign()">Reset alignment</button>
      } @else if (!autoTransform) {
        <button type="button" class="link-button mat-body-1" data-testid="drawing-compare-align" (click)="startAlign()">Lines look doubled? Align manually</button>
      }
    }
    <button type="button" mat-icon-button class="overlay-more" data-testid="drawing-compare-overlay-more" aria-label="Overlay options"
      [matMenuTriggerFor]="overlayMenu"><mat-icon>more_horiz</mat-icon></button>
  </div>
  <div class="legend mat-caption" data-testid="drawing-compare-legend">
    <span><i class="swatch swatch--removed"></i>Removed in {{ revisionName(newer) }}</span>
    <span><i class="swatch swatch--added"></i>Added in {{ revisionName(newer) }}</span>
    <span><i class="swatch swatch--both"></i>Unchanged</span>
  </div>

  @if (aligning) {
    <!-- Align manually: plain steps in an info strip; the marks on the sheet are numbered in the same red / blue -->
    <div class="align-steps" role="status" data-testid="drawing-compare-align-steps">
      <i class="align-steps-swatch" [class.align-steps-swatch--b]="aligning.length % 2 === 1" aria-hidden="true"></i>
      <span class="align-steps-text">{{ alignStep }}</span>
      <button type="button" class="link-button" data-testid="drawing-compare-align-cancel" (click)="cancelAlign()">Cancel</button>
    </div>
  }

  <div class="overlay-shell">
    <div #frame class="overlay-frame" [class.overlay-frame--zoomed]="zoom > 1" [class.overlay-frame--aligning]="!!aligning" data-testid="drawing-compare-overlay-frame"
      (wheel)="onWheel($event)" (pointerdown)="onPointerDown($event)" (pointermove)="onPointerMove($event)" (pointerup)="onPointerUp($event)"
      (pointercancel)="onPointerUp($event)" (lostpointercapture)="endPan()">
      @if (loadError) {
        <p class="overlay-empty mat-body-1" role="alert">{{ loadError }}</p>
      }
      <div class="overlay-page" [style.width.px]="pageWidthPx" [hidden]="!pageWidthPx || !!loadError">
        <canvas #view class="overlay-canvas" data-testid="drawing-compare-overlay-canvas" (click)="onCanvasClick($event)"></canvas>
        @for (p of aligning ?? []; track $index) {
          @let shown = shownMark(p, $index);
          <span class="align-mark" [class.align-mark--b]="$index % 2 === 1" [style.left.%]="markLeft(shown)" [style.top.%]="markTop(shown)">{{ markNumber($index) }}</span>
        }
      </div>
    </div>
    <app-sheet-zoom-controls testIdPrefix="drawing-compare" [zoom]="zoom" [canZoomIn]="canZoomIn" [canZoomOut]="canZoomOut"
      (zoomIn)="zoomBy(1)" (zoomOut)="zoomBy(-1)" />
  </div>
  <!-- Outside the controls row (its items share one centre line): always reachable, auto-aligned or not -->
  <mat-menu #overlayMenu="matMenu" xPosition="before">
    <button mat-menu-item type="button" data-testid="drawing-compare-align-manual" [disabled]="!!aligning" (click)="startAlign()">Align manually</button>
    @if (aligned) {
      <button mat-menu-item type="button" data-testid="drawing-compare-align-reset-menu" (click)="resetAlign()">Reset alignment</button>
    }
  </mat-menu>
</div>
